import { SettingsIcon } from 'foundations-assets/icons/components/SettingsIcon';
import { Flex } from 'foundations-components/components/Flex';
import { ToolDropdown } from '../ToolDropdown';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const DropdownContent = styled.div.withConfig({
  displayName: "DropdownToolContent__DropdownContent"
})(({
  theme
}) => ({
  padding: theme.space['400'],
  minWidth: '280px',
  overflow: 'hidden'
}));
export function DropdownToolContent({
  info,
  config,
  children
}) {
  var _config$getIcon;
  const Icon = ((_config$getIcon = config.getIcon) === null || _config$getIcon === void 0 ? void 0 : _config$getIcon.call(config, info.field)) || SettingsIcon;
  const label = config.getLabel(info.field);
  return /*#__PURE__*/_jsx(ToolDropdown, {
    Icon: Icon,
    tooltipTitle: label,
    children: /*#__PURE__*/_jsx(DropdownContent, {
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "300",
        children: children
      })
    })
  });
}